// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"20":"13f440a3","41":"101bfb35","135":"996623e7","378":"03d8ea68","417":"f06d0ca6","566":"3998bbc2","810":"d73ee0e2","837":"1687e8d1","858":"9cf54b9e"}[chunkId] + ".js";
};